import { ReactComponent as IconAdd } from "assets/svg/add.svg";
import * as React from "react";

import DashboardsListing from "components/cards/dashboards-listing";

// Icons
import { PageContext } from "components/layout/page-context";
import { useContext, useEffect } from "react";
import { Link } from "react-router-dom";

const DashboardsPage: React.FunctionComponent = () => {
  const page = useContext(PageContext);

  useEffect(() => {
    page.setTitle("Manage Dashboards");
    page.setBackLink();
    page.setShowsClientSwitcher(false);
  });

  return (
    <section className="c-block c-block--spacing-b-small">
      <div className="o-container-fluid o-container--full">
        <div className="c-page-title">
          <h2 className="c-title--large">All dashboards</h2>
          <Link
            to="/dashboards/new/general"
            className="c-button c-button--stroke c-button--secondary c-button--icon u-hidden@md"
          >
            <IconAdd className="o-svg-icon" />
          </Link>
          <Link
            to="/dashboards/new/general"
            className="c-button c-button--stroke c-button--secondary u-hidden u-block@md"
          >
            <span>Add new dashboard</span>
          </Link>
        </div>
        <DashboardsListing />
      </div>
    </section>
  );
};

export default DashboardsPage;
